import type { ReactNode } from "react";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({
  eyebrow,
  title,
  subtitle,
  actions,
}: PageHeaderProps): JSX.Element {
  return (
    <div className="page-header">
      <div>
        {eyebrow && (
          <span
            className="badge badge--info"
            style={{ marginBottom: 8, display: "inline-flex" }}
          >
            {eyebrow}
          </span>
        )}
        <h1 className="page-header__title">{title}</h1>
        {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}
